import React, { useContext } from 'react';
import { RouteContext } from 'entries/common/widgets/context';
import { SurfaceForm as Surfaces } from '../surface';
import { DimensionsForm as Dimensions } from '../dimensions';
import { Calculation } from '../calculation';

export const routes = {
  surface: 'surface',
  dimensions: 'dimensions',
  calculation: 'calculation',
};

export const FormRouter = () => {
  const { context: currentRoute } = useContext(RouteContext);
  switch (currentRoute) {
    case routes.surface:
      return <Surfaces />;
    case routes.dimensions:
      return <Dimensions />;
    case routes.calculation:
      return <Calculation />;
    default:
      return <div>default</div>;
  }
};
